const ALL_OPTIONS = [
  { label: 'Billions', value: 'Billions' },
  { label: 'Millions', value: 'Millions' },
  { label: 'Thousands', value: 'Thousands' },
] as const;

// Scale options for value display
// Order: Billions, Millions, Thousands
// Default: Always Millions
export const SCALE_CONFIG = {
  DEFAULT: 'Millions',
  OPTIONS: ALL_OPTIONS,
} as const;

export type ScaleValue = (typeof ALL_OPTIONS)[number]['value'];
